"use client";

import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "@/lib/query-keys";

import { useCurrentUser } from "@/features/auth/hooks/use-current-user";
import { notificationsRepository } from "@/features/notifications/api/notifications-repository";

/** Poll interval for the navbar badge (cross-cutting spec: 60s). */
export const NOTIFICATION_POLL_MS = 60_000;

/**
 * Global notification counts that drive the navbar badge. Polls every 60s while
 * the user is signed in (the cross-cutting requirement), and is disabled when
 * signed out so anonymous visitors never hit the authed endpoint. Keeps polling
 * in the background so the badge stays fresh across tabs/pages.
 */
export function useNotificationCounts() {
  const { isAuthenticated } = useCurrentUser();

  return useQuery({
    queryKey: queryKeys.notifications.counts(),
    queryFn: () => notificationsRepository.getCounts(),
    enabled: isAuthenticated,
    refetchInterval: NOTIFICATION_POLL_MS,
    refetchIntervalInBackground: true,
    // The badge is ambient chrome — a failed poll shouldn't surface an error UI.
    meta: { suppressGlobalError: true },
  });
}
